import React, { useState } from 'react';
import { api, rememberCode } from './api.js';
import Modal from './Modal.jsx';

function slugify(value) {
  return value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

export default function NewSetForm({ onClose, onCreated }) {
  const [name, setName] = useState(String(new Date().getFullYear() + 1));
  const [slug, setSlug] = useState('');
  const [adminCode, setAdminCode] = useState('');
  const [description, setDescription] = useState('');
  const [predictionsMadeOn, setPredictionsMadeOn] = useState(new Date().toISOString().slice(0, 10));
  const [isPrivate, setIsPrivate] = useState(true);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const effectiveSlug = slug.trim() ? slugify(slug) : slugify(name);

  async function handleSubmit(event) {
    event.preventDefault();
    if (!adminCode.trim()) {
      setError('Pick an admin code — it is the only way back in to edit this set.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const result = await api.createSet({
        name: name.trim(),
        slug: effectiveSlug,
        adminCode: adminCode.trim(),
        description: description.trim(),
        predictionsMadeOn: predictionsMadeOn || null,
        isPrivate
      });
      rememberCode(result.slug, adminCode.trim());
      onCreated(result.slug);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  }

  return (
    <Modal title="New prediction set" onClose={onClose}>
      <form className="pred-form" onSubmit={handleSubmit}>
        <label>
          <span>Name</span>
          <input value={name} onChange={e => setName(e.target.value)} required />
        </label>

        <label>
          <span>URL slug</span>
          <input
            value={slug}
            placeholder={slugify(name) || 'e.g. 2027'}
            onChange={e => setSlug(e.target.value)}
          />
          <small>/set.html?slug={effectiveSlug || '…'}</small>
        </label>

        <label>
          <span>Admin code</span>
          <input
            type="password"
            value={adminCode}
            onChange={e => setAdminCode(e.target.value)}
            required
          />
          <small>
            Required to edit this set, and to read it while it is private. Stored as plain text and
            not recoverable, so don't reuse a password.
          </small>
        </label>

        <label>
          <span>Date predictions written</span>
          <input
            type="date"
            value={predictionsMadeOn}
            onChange={e => setPredictionsMadeOn(e.target.value)}
          />
        </label>

        <label>
          <span>Description</span>
          <textarea rows="2" value={description} onChange={e => setDescription(e.target.value)} />
        </label>

        <label className="pred-checkbox">
          <input type="checkbox" checked={isPrivate} onChange={e => setIsPrivate(e.target.checked)} />
          <span>
            Private — hide from the public list and require the admin code to read.
          </span>
        </label>

        {error && <p className="pred-error">{error}</p>}

        <div className="pred-form-actions">
          <button type="button" className="pred-btn pred-btn-quiet" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="pred-btn pred-btn-primary" disabled={saving}>
            {saving ? 'Creating…' : 'Create set'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
